import React from 'react';
import NumberFormat from 'react-number-format';




export default class ZestawieniaPrint extends React.Component {




render() {

const { pokazdane, data, uchwala, text1, text2, wydzialy } = this.props;

return (<React.Fragment>
<p className='text-right mr-2 mb-2'>{uchwala}</p>
<h5 className='text-center'>{text1} {wydzialy.length === 1 ? wydzialy[0].label : null} </h5>
<table id="Tabela" class="table table-bordered mt-1">   
<thead >
<tr >
    <th class="text-center" style={{ width: '200px'}} onClick={() => this.sortowanieCyfry('dzial')}><b>Dział</b></th>
    <th class="text-center" onClick={() => this.sortowanieCyfry('rozdzial')}><b>Rozdział</b></th>
    <th class="text-center" onClick={() => this.sortowanieCyfry('paragraf')}><b>Paragraf</b></th>
    <th class="text-center" onClick={() => this.sortowanieCyfry('pozycja')}><b>Pozycja</b></th>
    <th class="text-center" onClick={() => this.sortowanieNazwy('rodzaj')}><b>Rodzaj</b></th>
    <th class="text-center" onClick={() => this.sortowanieNazwy('wydzial')}><b>Wydział</b></th>
    <th class="text-center" onClick={() => this.sortowanieNazwy('nazwa')}><b>Nazwa</b></th>
    <th class="text-center col-md-2" onClick={() => this.sortowanieCyfry('poczatkowy')}><b>Plan początkowy</b></th>
    <th class="text-center col-md-2" onClick={() => this.sortowanieCyfry('przed')}><b>Przed zmianą</b></th>
    <th class="text-center col-md-2" onClick={() => this.sortowanieCyfry('zmniejszenia')}><b>Zmniejszenia</b></th>    
    <th class="text-center col-md-2" onClick={() => this.sortowanieCyfry('zwiekszenia')}><b>Zwiększenia</b></th>    
    <th class="text-center col-md-2" onClick={() => this.sortowanieCyfry('po')}><b>Po zmianach</b></th>
    <th class="text-center" onClick={() => this.sortowanieCyfry('wniosek')}><b>Wniosek</b></th>
</tr>
</thead>
<tbody>
{ pokazdane ? (<>
  {data.dane.map(user => {
  const { rozdzial, dzial, paragraf, rodzaj, wydzial, nazwa, poczatkowy, przed,  pozycja, zmniejszenia, zwiekszenia, po, wniosek, zadania} = user;
  return (    
  <React.Fragment>
    <tr>
      <td style={{ width: '15'}}><p>{dzial}</p></td>
      <td style={{ width: '4%'}}><p>{rozdzial}</p></td>
      <td style={{ width: '3%'}}><p>{paragraf}</p></td>
      <td style={{ width: '3%'}}><p>{pozycja}</p></td>
      <td style={{ width: '4%'}}><p>{rodzaj}</p></td>
      <td style={{ width: '4%'}}><p>{wydzial}</p></td>
      <td ><p>{nazwa}</p></td>
      <td ><p className="text-right"><NumberFormat value={poczatkowy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
      <td ><p className="text-right"><NumberFormat value={przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td> 
      <td ><p className="text-right"><NumberFormat value={zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
      <td ><p className="text-right"><NumberFormat value={zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>   
      <td ><p className="text-right"><NumberFormat value={po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
      <td ><p className="text-right"><NumberFormat value={wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    </tr>
    {zadania ? (<>
    {zadania.length > 0 ? ( <tr ><td colSpan="13">
    <center><h4>Zadania</h4></center>
    <table class="table table-sm rowZadania">
    <thead>
    <tr >
    <th scope="col" class="text-center" ><b>Nazwa</b></th>
    <th scope="col" class="text-center" ><b>Początkowy</b></th>
    <th scope="col" class="text-center" ><b>Przed</b></th>
    <th scope="col" class="text-center" ><b>Zmniejszenia</b></th>
    <th scope="col" class="text-center" ><b>Zwiększenia</b></th>
    <th scope="col" class="text-center" ><b>Po</b></th>
    </tr>
    </thead>
    <tbody>
    {zadania.map(elem => {
    const { nazwa, poczatkowy, przed, zmniejszenia, zwiekszenia, po } = elem;
    return (
    <tr>
      <td class="text-right">{nazwa}</td>
      <td class="text-right">{poczatkowy}</td>
      <td class="text-right">{przed}</td>
      <td class="text-right">{zmniejszenia}</td>
      <td class="text-right">{zwiekszenia}</td>
      <td class="text-right">{po}</td>
    </tr>
    );
    })
    }
    </tbody>
    </table>
    </td></tr> 
    ) : null } </>) : null }
  </React.Fragment>
    );
  })}
  <tr>
    <td colSpan="7" rowspan="2"><div ><p><b>SUMA</b></p></div></td>
    <td><p><b>Początkowy</b></p></td>
    <td><p><b>Przed</b></p></td>
    <td><p><b>Zmniejszenia</b></p></td>
    <td><p><b>Zwiększenia</b></p></td>
    <td><p><b>Po</b></p></td>
    <td><p><b>Wniosek</b></p></td>
  </tr>
  <tr>
    <td><p><NumberFormat value={data.poczatkowy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    <td><p><NumberFormat value={data.przed} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    <td><p><NumberFormat value={data.zmniejszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    <td><p><NumberFormat value={data.zwiekszenia} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    <td><p><NumberFormat value={data.po} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
    <td><p><NumberFormat value={data.wniosek} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></p></td>
  </tr>
  </>) : (<tr ><td colSpan="13"><center><p>Brak danych</p></center></td></tr>) }

</tbody>

</table>
</React.Fragment>);

}

}

